import {useState} from 'react'
import PropTypes from 'prop-types'
import {List} from 'immutable'

import TfaWizardStepFrame from './TfaWizardStepFrame'
import UnorderedList from '../../../../../shared_components/UnorderedList'

import finishTfaSetup from '../../../../../shared_assets/finishTFASetup.png'
import {findResourceByAttributeId} from '../../../../../lib/plan_data/userData'


const Enabled = props => {
  const [loading, setLoading] = useState(false)
  const tfaEnrollment = findResourceByAttributeId({resourceList: props.tfaEnrollments, attribute: 'mode', id: props.enrollmentMode})

  const handleRedirect = event => {
    if (event) event.preventDefault()

    props.logMixpanelEvent('2fa_setup_complete')
    setLoading(true)

    props.readEndpoint('user-configs')
      .then(() => props.exitTfa())
      .catch(() => { setLoading(false) })
  }

  const instructionsList = () => {
    let instructions = ["You'll be asked for a verification code each time you sign in"]

    if (tfaEnrollment.get('mode') === 'app')
      instructions = [...instructions, 'Use backup codes if you lose access to your authenticator', 'If you get a new phone, use the built-in export or sync feature in your authenticator app to transfer data']
    else
      instructions.push('You will receive the verification code via SMS')

    return instructions
  }

  return (
    <TfaWizardStepFrame
      currentStep={5}
      onPrimaryAction={handleRedirect}
      primaryActionLabel='Done'
      primaryLoading={loading}
      subtitle='Two-factor authentication is now enabled on your account.'
      title="You're all set!">
      <div className='tfa-enabled-step'>
        <div className='tfa-enabled-visual'>
          <img alt='Two-factor authentication enabled' src={finishTfaSetup} />
        </div>
        <div className='tfa-enabled-copy'>
          <p className='tfa-enabled-next-title'>What happens next?</p>
          <UnorderedList
            children={instructionsList()}
          />
        </div>
      </div>
    </TfaWizardStepFrame>
  )
}

Enabled.propTypes = {
  currentUser: PropTypes.object,
  logMixpanelEvent: PropTypes.func,
  tfaEnrollments: PropTypes.instanceOf(List).isRequired,
  enrollmentMode: PropTypes.string.isRequired,
  readEndpoint: PropTypes.func.isRequired,
  exitTfa: PropTypes.func.isRequired
}

export default Enabled
